import { Group, PrivacySetting } from '../types/group'
import { User } from '../types/user'

const groupWithChildrenRecursively = (groups: Group[], currentGroup: Group): Group[] => {
  const children = groups
    .filter(group => group.parent_id === currentGroup.id)
    .map(group => groupWithChildrenRecursively(groups, group))

  return [currentGroup].concat(...children)
}

export const groupWithChildren = (groups: Group[], groupId: number): Group[] => {
  const currentGroup = groups.find(group => group.id === groupId)

  if (!currentGroup) {
    return []
  }

  return groupWithChildrenRecursively(groups, currentGroup)
}

export const getInitialGroupsForFilters = (groups: Group[], { account, team }: User): Group[] => {
  if (
    account.group_id &&
    ((team.group_privacy_setting === PrivacySetting.ALL_PUBLIC &&
      team.default_filter_content_by_group) ||
      team.group_privacy_setting === PrivacySetting.GROUP_PUBLIC)
  ) {
    return groupWithChildren(groups, account.group_id)
  }

  return []
}
